<template>
  <div class="wrapper-previews-Item">
    <div class="box avatar image-container">
      <el-image class="logo" :src="order.location.logo">
        <div slot="placeholder" class="image-slot">
          <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw"></i>
        </div>
        <div slot="error" class="image-slot text">
          {{ order.location.name.substring(0, 2) | capitalize }}
        </div>
      </el-image>
    </div>
    <div class="box price">
      <p>{{ order.total_price | currency(currentCurrency) }}</p>
    </div>
    <div class="box order-status">
      <div class="order-status-grid">
        <p>{{ getLastStatus(order).text }}</p>
        <span :style="{ 'background-color': getLastStatus(order).color }" class="grid-dot dot"></span>
      </div>
    </div>
    <div class="box payment_type">
      <i :class="
        getPaymentTypeIcon(order.order_payment_type_id, true)
      "></i>
    </div>
    <div class="box date">
      {{
        generateFormatedDateTime(
          order.created_at,
          "date",
          "DD MMM YYYY HH:mm"
        )
      }}
    </div>
    <div class="box counter">
      <i class="k-icon-basket-2"></i>
      {{ $t("text.counter_items", { counter: order.orderItems.length }) }}
    </div>
    <div class="box items">
      <el-collapse>
        <el-collapse-item>
          <template slot="title">
            <div v-html="
              getViewOrderTitle(order.id, order.order_type)
            "></div>
          </template>
          <div v-html="orderItemsFormatter(order.orderItems)"></div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import { generateFormatedDateTime, getPaymentTypeIcon, getLastOrderStatus, getViewOrderTitle, orderItemsFormatter } from "@/utilities/helper";
export default {
  props: {
    order:Object
  },
  computed:{
    getLastStatus() {
      return (order) => {
        return getLastOrderStatus({ order_status: order.order_status });
      };
    },
  },
  data() {
    return {
      orderItemsFormatter,
      generateFormatedDateTime,
      getPaymentTypeIcon,
      getViewOrderTitle,
      loadingStatus: false,
    };
  },
  
}
</script>